<template>
  <div class="publicActions text-center">
      <MoreInfoPopover target='phone' width="auto">
        0800 243 779
      </MoreInfoPopover>
      <router-link
        :to="{name:'login', query:{redirect:$route.path}}"
        class="noStyle"
      >Login</router-link>
      <router-link
        :to="{name:'signup', query:{redirect:$route.path}}"
        class="noStyle"
      >Sign up</router-link>
  </div>
</template>

<script>
import MoreInfoPopover from "@/components/MoreInfoPopover"

export default {
  name: 'PublicActions',
  components: {
    MoreInfoPopover
  }
}
</script>

<style lang="scss" scoped>

@include media-breakpoint-down(md){
  .publicActions{
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.publicActions{
    a, span:first-child{
        color:$CTred;
        font-size: 0.8em;
        font-weight:bold;
        &:hover{
            text-decoration: underline;
        }
    }
    a:not(:last-of-type):after, span:first-child:after{
        content: "|";
        padding: 0 10px;

    }
}


</style>
